import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { StringUtil } from 'src/app/util/string-util';

@Component({
  selector: 'app-intl-tel-input',
  templateUrl: './intl-tel-input.component.html',
  styleUrls: ['./intl-tel-input.component.scss']
})
export class IntlTelInputComponent implements OnInit {
  @ViewChild('telInput') telInput;
  _phoneNumber: string = '';
  _disabled: boolean;
  @Input() id: string;
  @Output() phoneNumberChange = new EventEmitter<string>();
  @Output() isNumberValid = new EventEmitter<boolean>();

  preferredCountries: CountryISO[] = [CountryISO.Brazil, CountryISO.Argentina];
  iti;
  isInvalid = false;
  selectedCountryCode;

  phoneForm = new FormGroup({
    phone: new FormControl({
      value: this._phoneNumber,
      disabled: true
    }, [Validators.required])
  });

  @Input() set defaultValue(value: string) {
    if (value) {
      this.phoneForm.controls.phone.setValue(value);
    }
  }

  @Input() set disabled(value: boolean) {
    this._disabled = value
    if (value) this.phoneForm.controls['phone'].enable();
    else {
      this.phoneForm.controls['phone'].disable();
      this.phoneForm.controls.phone.setValue('');
    }
  }

  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.Brazil, CountryISO.Argentina];
  }

  constructor() {
    this.disabled = true;
  }

  ngOnInit() {}

  checkNumber = () => {
    const phoneControl = this.phoneForm.controls['phone'];
    const phoneValue = phoneControl.value;

    this.isInvalid = true;

    if (phoneControl.status === 'VALID' && phoneValue) {
      const e164Number = phoneValue.e164Number || '';
      const digitsOnly = e164Number.replace(/\D/g, '');
      const dialCode = phoneValue.dialCode || '';

      const numberWithoutCountryCode = StringUtil.removeCountryCode(digitsOnly, dialCode);

      if (!StringUtil.isFakePhoneNumber(numberWithoutCountryCode)) {
        this.isInvalid = false;
        this.phoneNumberChange.emit(digitsOnly);
      } else {
        this.phoneNumberChange.emit('');
      }
    } else {
      this.phoneNumberChange.emit('');
    }

    this.isNumberValid.emit(!this.isInvalid);
  };
}
